import React from 'react';
import { SystemConfig } from '@/types';
import { Layout } from 'lucide-react';
import { ImageUploader } from './settingsShared';

interface GeneralSectionProps {
  config: SystemConfig;
  onUpdate: (config: SystemConfig) => void;
}

export const GeneralSection: React.FC<GeneralSectionProps> = ({ config, onUpdate }) => (
  <div className="space-y-6 animate-fade-in">
    <div className="bg-white p-8 rounded-2xl border border-slate-200 shadow-sm">
      <h4 className="font-bold text-lg mb-6 text-slate-800 border-b pb-4 flex items-center gap-2">
        <Layout className="w-5 h-5 text-teal-600" /> Branding Settings
      </h4>
      <div className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label className="block text-xs font-bold text-slate-500 uppercase mb-2">
              Application Name
            </label>
            <input
              className="w-full border rounded-xl p-3 bg-slate-50 outline-none focus:ring-2 focus:ring-teal-500 font-bold"
              value={config.general.appName}
              onChange={(e) =>
                onUpdate({ ...config, general: { ...config.general, appName: e.target.value } })
              }
            />
          </div>
          <div>
            <label className="block text-xs font-bold text-slate-500 uppercase mb-2">
              Base App URL
            </label>
            <input
              className="w-full border rounded-xl p-3 bg-slate-50 outline-none focus:ring-2 focus:ring-teal-500 font-mono text-sm"
              value={config.general.appUrl}
              onChange={(e) =>
                onUpdate({ ...config, general: { ...config.general, appUrl: e.target.value } })
              }
            />
          </div>
          <div>
            <label className="block text-xs font-bold text-slate-500 uppercase mb-2">
              VAT Rate (%)
            </label>
            <input
              type="number"
              min={0}
              step={0.01}
              className="w-full border rounded-xl p-3 bg-slate-50 outline-none focus:ring-2 focus:ring-teal-500 font-mono text-sm"
              value={config.general.vatRatePercent ?? 0}
              onChange={(e) =>
                onUpdate({
                  ...config,
                  general: {
                    ...config.general,
                    vatRatePercent: Math.max(0, Number(e.target.value) || 0)
                  }
                })
              }
            />
          </div>
        </div>
        <ImageUploader
          label="Primary Brand Logo"
          currentImage={config.general.logoUrl}
          onImageChange={(url) =>
            onUpdate({ ...config, general: { ...config.general, logoUrl: url } })
          }
        />
      </div>
    </div>
  </div>
);
